export const storiesPerLoad = 10;
export const commentsPerLoad = 1;